import { HubConnectionBuilder, HubConnectionState, LogLevel } from "@microsoft/signalr";
import { eSesjaEventEmitter } from "../helpers/esesja.event.emitter";

const RECONNECT_DELAYS_MS = [1000, 5000, 10000, 30000];

class eSesjaInteractivePublicService {
    constructor() {
        this._hubConfig = {
            address: "/public-esesja-live",
            logLevel: LogLevel.Error
        }

        this._connectionState = {
            hub: false
        }

        this._hubConnection = null;
        this._connectPromise = null;
        this._ensureConnectionPromise = null;
        this._desiredRoom = null;
        this._joinedRoom = null;
        this._reconnectTimer = null;
        this._reconnectAttempt = 0;
        this._stopping = false;
        this.events = new eSesjaEventEmitter();
        this._parametrizeHubConnection();
    }
    //settery i gettery 
    get hubConfig() {
        return this._hubConfig;
    }
    get connectionComputedState() {
        return this._hubConnection !== null && this._hubConnection.state === HubConnectionState.Connected;
    }
    get connectionState() {
        return this._connectionState;
    }

    //create connection
    //hub
    _parametrizeHubConnection() {
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(this._hubConfig.address)
            .withAutomaticReconnect()
            .configureLogging(this._hubConfig.logLevel)
            .build();

        this._hubConnection.on("ActiveAgendaPointChange", async (obj, status) => {
            var data = {
                point: obj,
                status: status
            };
            this.events.emit("ActiveAgendaPointChange", data);
        });

        this._hubConnection.on("SetDonePoint", async (obj) => {
            this.events.emit("SetDonePoint", obj);
        });

        this._hubConnection.on("SessionBreakStatusChange", async (obj) => {
            this.events.emit("SessionBreakStatusChange", obj);
        });
        this._hubConnection.on("ShowHideVotingResultsLive", async (obj) => {
            this.events.emit("ShowHideVotingResultsLive", obj);
        });
        this._hubConnection.on("AddTimeToSpeakerForPublic", async (obj) => {
            this.events.emit("AddTimeToSpeakerForPublic", obj);
        });
        this._hubConnection.on("CloseVotingResultModal", async (obj) => {
            this.events.emit("CloseVotingResultModal", obj);
        });
        this._hubConnection.on("CloseResultCheckQuorumModal", async (obj) => {
            this.events.emit("CloseResultCheckQuorumModal", obj);
        });
        this._hubConnection.on("CurrentAgendaItems", async (obj) => {
            this.events.emit("CurrentAgendaItems", obj);
        });
        this._hubConnection.on("UserStartSpeech", async (obj) => {
            this.events.emit("UserStartSpeech", obj);
        });
        this._hubConnection.on("UserEndSpeech", async (obj) => {
            this.events.emit("UserEndSpeech", obj);
        });
        this._hubConnection.on("QuorumStarted", async (obj) => {
            this.events.emit("QuorumStarted", obj);
        });
        this._hubConnection.on("QuorumEnded", async (obj) => {
            this.events.emit("QuorumEnded", obj);
        });
        this._hubConnection.on("QuorumResultsChanged", async (sessionId, data) => {
            this.events.emit("QuorumResultsChanged", data);
        });
        this._hubConnection.on("QuorumSummaryReults", async (councilid, obj) => {
            this.events.emit("QuorumSummaryReults", obj);
        });
        this._hubConnection.on("VotingStarted", async (obj) => {
            this.events.emit("VotingStarted", obj);
        });
        this._hubConnection.on("OpenInteractiveVotingPublic", async (obj) => {
            this.events.emit("OpenInteractiveVotingPublic", obj);
        });
        this._hubConnection.on("VotingEnded", async (obj) => {
            this.events.emit("VotingEnded", obj);
        });
        this._hubConnection.on("VoteResultChanged", async (obj) => {
            this.events.emit("VoteResultChanged", obj);
        });
        this._hubConnection.on("VoteResultSummary", async (obj, obj2) => {

            var data = {
                u: obj,
                s: obj2
            };

            this.events.emit("VoteResultSummary", data);
        });
        this._hubConnection.on("VoiceRequestListChanged", async (obj) => {
            this.events.emit("VoiceRequestListChanged", obj);
        });

        this._hubConnection.on("OpenAttachment", (sessionId, ssoToken, page, scale) => {
            var data = {
                sessionId: sessionId,
                ssoToken: ssoToken,
                page: page,
                scale: scale
            }
            this.events.emit("OpenAttachment", data);
        })

        this._hubConnection.on("ChangeAttachemtnPage", (sessionId, page, scale) => {
            var data = {
                sessionId: sessionId,
                page: page,
                scale: scale
            }
            this.events.emit("ChangeAttachemtnPage", data);
        })

        this._hubConnection.on("ScroolAttachmentPage", (sessionId, percent) => {
            var data = {
                sessionId: sessionId,
                percent: percent
            }
            this.events.emit("ScroolAttachmentPage", data);
        })


        this._hubConnection.on("CloseAttachemnt", sessionId => {
            this.events.emit("CloseAttachemnt", sessionId);
        })

        this._hubConnection.on("ChangePlaceholderStatus", (placeholder, isActive) => {
            var data = {
                placeholder: placeholder,
                isActive: isActive
            }
            this.events.emit("ChangePlaceholderStatus", data);
        })

        this._hubConnection.on("CurrentClientSettings", settings => {
            this.events.emit("CurrentClientSettings", settings);
        });

        this._hubConnection.on("StartDummySpeech", obj => {
            this.events.emit("StartDummySpeech", obj);
        });


        this._hubConnection.on("EndDummySpeech", () => {
            this.events.emit("EndDummySpeech", null);
        });
        this._hubConnection.onreconnecting(() => {
            this._connectionState.hub = false;
            this._joinedRoom = null;
        });

        this._hubConnection.onreconnected(async (connectionId) => {
            this._connectionState.hub = true;
            this._joinedRoom = null;
            this._reconnectAttempt = 0;

            try {
                if (this._desiredRoom !== null) {
                    const joined = await this.ensureConnectedAndJoined(this._desiredRoom);
                    if (!joined) {
                        this._scheduleReconnect();
                        return;
                    }
                }

                this.events.emit("SignalRReconnected", connectionId);
            }
            catch (e) {
                console.log(e);
                this._scheduleReconnect();
            }
        });

        this._hubConnection.onclose(() => {
            this._connectionState.hub = false;
            this._joinedRoom = null;
            this._scheduleReconnect();
        });
    }

    async _hubConnect() {
        if (this._hubConnection === null) {
            throw new Error("Hub is not parametrized!");
        }

        if (this._hubConnection.state === HubConnectionState.Connected) {
            this._connectionState.hub = true;
            return true;
        }

        if (this._hubConnection.state === HubConnectionState.Connecting ||
            this._hubConnection.state === HubConnectionState.Reconnecting) {
            this._connectionState.hub = false;
            return false;
        }

        if (this._hubConnection.state !== HubConnectionState.Disconnected) {
            this._connectionState.hub = false;
            return false;
        }

        if (this._connectPromise === null) {
            this._connectPromise = this._hubConnection.start()
                .then(() => {
                    this._connectionState.hub = true;
                    this._reconnectAttempt = 0;
                    return true;
                })
                .catch((e) => {
                    this._connectionState.hub = false;
                    throw e;
                })
                .finally(() => {
                    this._connectPromise = null;
                });
        }

        return await this._connectPromise;
    }

    async _connectAndJoinDesiredRoom() {
        const connected = await this._hubConnect();
        if (!connected) {
            return false;
        }

        const room = this._desiredRoom;
        if (room === null || this._joinedRoom === room) {
            return true;
        }

        await this._hubConnection.invoke("Join", room);

        if (this._desiredRoom === room) {
            this._joinedRoom = room;
        }

        return this._joinedRoom === room;
    }

    _clearReconnectTimer() {
        if (this._reconnectTimer !== null) {
            clearTimeout(this._reconnectTimer);
            this._reconnectTimer = null;
        }
    }

    _scheduleReconnect() {
        if (this._stopping || this._desiredRoom === null || this._reconnectTimer !== null) {
            return;
        }

        const delayIndex = Math.min(this._reconnectAttempt, RECONNECT_DELAYS_MS.length - 1);
        const delay = RECONNECT_DELAYS_MS[delayIndex];
        this._reconnectAttempt += 1;

        this._reconnectTimer = setTimeout(async () => {
            this._reconnectTimer = null;

            if (this._stopping || this._desiredRoom === null) {
                return;
            }

            try {
                const recovered = await this.ensureConnectedAndJoined(this._desiredRoom);
                if (recovered) {
                    this._reconnectAttempt = 0;
                    this.events.emit("SignalRReconnected");
                    return;
                }
            }
            catch (e) {
                console.log(e);
            }

            this._scheduleReconnect();
        }, delay);
    }

    async ensureConnectedAndJoined(room) {
        if (room === null || room === undefined || `${room}`.length === 0) {
            throw new Error("Room is required!");
        }

        this._stopping = false;
        this._desiredRoom = `${room}`;

        if (this._ensureConnectionPromise === null) {
            this._ensureConnectionPromise = this._connectAndJoinDesiredRoom()
                .finally(() => {
                    this._ensureConnectionPromise = null;
                });
        }

        try {
            const connectedAndJoined = await this._ensureConnectionPromise;

            if (!connectedAndJoined || this._joinedRoom !== this._desiredRoom) {
                this._scheduleReconnect();
                return false;
            }

            this._clearReconnectTimer();
            this._reconnectAttempt = 0;
            return true;
        }
        catch (e) {
            this._scheduleReconnect();
            throw e;
        }
    }

    async joinRoom(obj) {
        return await this.ensureConnectedAndJoined(obj);
    }

    async leaveRoom(obj) {
        if (this._hubConnection === null) {
            throw new Error("Hub is not parametrized!");
        }

        const room = `${obj}`;
        if (this._desiredRoom === room) {
            this._desiredRoom = null;
            this._clearReconnectTimer();
        }

        if (this._hubConnection.state !== HubConnectionState.Connected) {
            if (this._joinedRoom === room) {
                this._joinedRoom = null;
            }

            return;
        }

        await this._hubConnection.invoke("Leave", room);

        if (this._joinedRoom === room) {
            this._joinedRoom = null;
        }
    }

    async start() {
        this._stopping = false;
        await this._hubConnect();
        return this.connectionComputedState;
    }

    async stop() {
        if (this._hubConnection === null) {
            throw new Error("Hub is not parametrized!");
        }

        this._stopping = true;
        this._desiredRoom = null;
        this._joinedRoom = null;
        this._clearReconnectTimer();

        if (this._hubConnection.state !== HubConnectionState.Disconnected) {
            await this._hubConnection.stop();
        }

        this._connectionState.hub = false;
    }
}

export default new eSesjaInteractivePublicService();
